/** Admin > Products > POP Authority: filter options and formatting shared by the six tabs. */

export const PA_ADMIN_PER_PAGE_OPTIONS = [10, 15, 25, 50]

/** Stage filter of Customer Overview (specs "Admin dashboard/statuses.txt"). */
export const PA_ADMIN_STAGE_OPTIONS = [
  { key: 'all', label: 'All' },
  { key: 'setup', label: 'Setup' },
  { key: 'audit', label: 'Audit & plans' },
  { key: 'package', label: 'Package pending payment' },
  { key: 'active', label: 'Active campaign' },
  { key: 'ended', label: 'Ended or paused' },
  { key: 'exception', label: 'Payment exception' },
]

export const PA_ADMIN_PACKAGE_OPTIONS = [
  { key: 'all', label: 'All' },
  { key: 'starter', label: 'Authority Starter' },
  { key: 'growth', label: 'Authority Growth' },
  { key: 'pro', label: 'Authority Pro' },
  { key: 'custom', label: 'Authority Custom' },
]

/** Customer Overview also lists the projects without a package. */
export const PA_ADMIN_PACKAGE_OPTIONS_WITH_NONE = [
  ...PA_ADMIN_PACKAGE_OPTIONS,
  { key: 'none', label: 'No package' },
]

export const PA_ADMIN_ORDER_TYPE_OPTIONS = [
  { key: 'all', label: 'All' },
  { key: 'setup_fee', label: 'Setup fee' },
  { key: 'package_month', label: 'Package month' },
  { key: 'content_order', label: 'Content order' },
  { key: 'booster', label: 'Booster' },
]

/** '$1,234.50': the design shows every amount with two decimals. */
export function paAdminMoney (value) {
  const n = Number(value)
  if (value === null || value === undefined || value === '' || !Number.isFinite(n)) return ''
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** 'YYYY-MM-DD' of an API datetime ('YYYY-MM-DD HH:MM:SS'). */
export function paAdminDate (value) {
  return value ? String(value).slice(0, 10) : ''
}

export function paAdminCsvCell (value) {
  if (value === null || value === undefined) return '""'
  return '"' + String(value).replace(/"/g, '""') + '"'
}

/** rows: arrays of cells (the first one is the header). Labels carry commas, so every cell is quoted. */
export function paAdminDownloadCsv (fileName, rows) {
  const text = rows.map((row) => row.map(paAdminCsvCell).join(',')).join('\n')
  const link = document.createElement('a')
  const url = window.URL.createObjectURL(new Blob([text], { type: 'text/csv' }))
  link.download = fileName
  link.href = url
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

/** 'pop-authority-setup-fees_2026-09-29.csv' */
export function paAdminCsvName (tab) {
  const now = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  return `pop-authority-${tab}_${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.csv`
}
